// Auth V1 runtime logo. Approved gold lockup, used as delivered — no recolor, stretch or glow.
export const AuthLogo = ({ width = 180, className = '' }) => (
  <img
    src="/auth/v1/arvexis-logo-gold.webp"
    alt="Arvexis"
    style={{ width, height: 'auto' }}
    className={`select-none ${className}`}
    draggable="false"
    data-testid="auth-logo"
  />
);

export default AuthLogo;
